(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const HOLUS_DESKTOP_BREAKPOINT = 990;

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this._headerMetricsFrame = null;
      this._requestHeaderMetricsSync = this.requestHeaderMetricsSync.bind(this);
      this._syncHeaderMetrics = this.syncHeaderMetrics.bind(this);
      this._breakpointChangeMedia = window.matchMedia('(max-width: 990px)');
      this._handleBreakpointChange = this.handleBreakpointChange.bind(this);

      this.syncHeaderMetrics();

      this._breakpointChangeMedia.addEventListener('change', this._handleBreakpointChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.expandedHeaderHeight = 0;
      this.compactHeaderHeight = 0;
      this.sentinel = null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this._requestHeaderMetricsSync);
      window.addEventListener('load', this._requestHeaderMetricsSync);

      if (this.header) {
        this.header.addEventListener('transitionrun', this._requestHeaderMetricsSync);
        this.header.addEventListener('transitionend', this._requestHeaderMetricsSync);
      }

      if (window.ResizeObserver && this.header) {
        this.headerResizeObserver = new ResizeObserver(this._requestHeaderMetricsSync);
        this.headerResizeObserver.observe(this.header);
      }

      this.createObserver();
      this.requestHeaderMetricsSync();
    }

    toggleScrolledPastHeader(value) {
      this.header.classList.toggle('scrolled-past-header', value);
      this.requestHeaderMetricsSync();
    }

    isDesktopHolusNav() {
      return window.innerWidth >= HOLUS_DESKTOP_BREAKPOINT && Boolean(this.header?.querySelector('.header--holus-nav'));
    }

    normalizeDesktopHolusNav() {
      if (!this.header || !this.isDesktopHolusNav()) return;
      this.header.classList.remove('scrolled-past-header');
    }

    handleBreakpointChange() {
      this.normalizeDesktopHolusNav();
      this.requestHeaderMetricsSync();
    }

    requestHeaderMetricsSync() {
      if (this._headerMetricsFrame !== null) return;

      this._headerMetricsFrame = window.requestAnimationFrame(() => {
        this._headerMetricsFrame = null;
        this.syncHeaderMetrics();
      });
    }

    syncHeaderMetrics() {
      if (!this.header) return;

      this.normalizeDesktopHolusNav();

      const headerHeight = Math.max(0, Math.ceil(this.header.offsetHeight || 0));
      const headerRect = this.header.getBoundingClientRect();
      // Position finale (sans la translation en cours) : les éléments sticky se calent
      // directement sur l'état masqué/affiché au lieu de suivre l'animation.
      const isHeaderHidden = this.header.classList.contains('shopify-section-header-hidden');
      const headerTranslateY = new DOMMatrixReadOnly(getComputedStyle(this.header).transform).m42;
      const visibleHeaderBottom = isHeaderHidden
        ? 0
        : Math.max(0, Math.ceil((headerRect.bottom || 0) - headerTranslateY));
      const isScrolledHeader = this.header.classList.contains('scrolled-past-header');

      if (isScrolledHeader) {
        this.compactHeaderHeight = headerHeight;
      } else {
        this.expandedHeaderHeight = headerHeight;
      }

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--holus-visible-header-bottom', `${visibleHeaderBottom}px`);
    }

    getNaturalHeaderVisibleHeight() {
      if (!this.sentinel || !this.expandedHeaderHeight) return 0;

      const sentinelTop = this.sentinel.getBoundingClientRect().top;

      return Math.max(0, Math.min(this.expandedHeaderHeight, sentinelTop));
    }

    shouldRestoreExpandedHeaderOnScrollUp() {
      const restoreRatio = 0.5;
      const visibleHeight = this.getNaturalHeaderVisibleHeight();
      const restoreThreshold = (this.expandedHeaderHeight || 0) * restoreRatio;

      return visibleHeight >= restoreThreshold && restoreThreshold > 0;
    }

    setScrolledPastHeader(shouldBeScrolled) {
      this.toggleScrolledPastHeader(shouldBeScrolled);
    }

    // Supprime les transitions CSS le temps d'agrandir le header (compact → étendu)
    // pour éviter que la croissance de max-height (logo, 420ms) décale le contenu.
    _expandWithoutLayoutShift() {
      const isCompactAndVisible =
        this.header.classList.contains('scrolled-past-header') &&
        !this.header.classList.contains('shopify-section-header-hidden');
      if (!isCompactAndVisible) {
        this.setScrolledPastHeader(false);
        return;
      }
      this.header.classList.add('holus-no-transition');
      this.header.offsetHeight; // force reflow
      this.setScrolledPastHeader(false);
      this.header.offsetHeight; // force reflow pour appliquer l'état étendu
      this.header.classList.remove('holus-no-transition');
    }

    setHeaderHeight() {
      this.syncHeaderMetrics();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this._requestHeaderMetricsSync);
      window.removeEventListener('load', this._requestHeaderMetricsSync);
      this._breakpointChangeMedia.removeEventListener('change', this._handleBreakpointChange);

      if (this.header) {
        this.header.removeEventListener('transitionrun', this._requestHeaderMetricsSync);
        this.header.removeEventListener('transitionend', this._requestHeaderMetricsSync);
      }

      if (this.headerResizeObserver) {
        this.headerResizeObserver.disconnect();
      }

      if (this._headerMetricsFrame !== null) {
        window.cancelAnimationFrame(this._headerMetricsFrame);
        this._headerMetricsFrame = null;
      }
    }

    createObserver() {
      // Bounds du header (utilisé pour hide/reveal, inchangé)
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);

      // Sentinel placé juste après le header dans le flux normal.
      // Quand il quitte le viewport → on est "scrolled past header".
      // Quand il revient → on repasse en état non-scrollé.
      this.sentinelVisible = true;
      this.sentinel = document.getElementById('holus-scroll-sentinel');
      if (this.sentinel) {
        new IntersectionObserver((entries) => {
          this.sentinelVisible = entries[0].isIntersecting;
        }, { threshold: 0 }).observe(this.sentinel);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isDesktopHolusNav()) {
        this.normalizeDesktopHolusNav();

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop) {
          this.revealUnlessPrevented();
        }

        this.currentScrollTop = scrollTop;
        this.requestHeaderMetricsSync();
        return;
      }

      // Tant que le sentinel est visible ET que le header est déjà en mode normal,
      // on le laisse dans sa position naturelle.
      if (this.sentinelVisible && !this.header.classList.contains('scrolled-past-header')) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop < this.currentScrollTop && this.shouldRestoreExpandedHeaderOnScrollUp()) {
        this._expandWithoutLayoutShift();
        requestAnimationFrame(this.reveal.bind(this));
        this.currentScrollTop = scrollTop;
        this.requestHeaderMetricsSync();
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setScrolledPastHeader(true);
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setScrolledPastHeader(true);
        this.revealUnlessPrevented();
      } else if (scrollTop <= this.headerBounds.top) {
        this._expandWithoutLayoutShift();
        requestAnimationFrame(this.reveal.bind(this));
      }

      this.currentScrollTop = scrollTop;
      this.requestHeaderMetricsSync();
    }

    revealUnlessPrevented() {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
        return;
      }

      window.clearTimeout(this.isScrolling);

      this.isScrolling = setTimeout(() => {
        this.preventReveal = false;
      }, 66);

      requestAnimationFrame(this.hide.bind(this));
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.requestHeaderMetricsSync();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.requestHeaderMetricsSync();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      // Retirer scrolled-past-header immédiatement et sans animation pour que la
      // hauteur soit correcte (expanded) avant de perdre position: sticky.
      // Sinon le header compact en position relative pousse le contenu.
      this.header.classList.add('holus-no-transition');
      this.header.classList.remove('scrolled-past-header');
      this.header.offsetHeight; // force reflow
      this.header.classList.remove('holus-no-transition');
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.requestHeaderMetricsSync();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
